
/* APPLICATION ROUTE CONSTANTS */

module.exports = Object.freeze({
  
    // Status
    SELF_REGISTRATION: '/self-registration',

    /* Routers Link supplier_app */
    APP_HOME: '/applications',
    HOME: '/home',
    HOME_INTRO:'/supplier-intro',
    DASHBOARD: '/dashboard',
    INBOX: '/inbox',
    OUTBOX: '/outbox',
    RESET_PASSWORD: '/reset-password',

    // SUPPILER
    SUPPILER_REGISTRATION: '/supplier-registration',
    SUPPILER_LIST: '/supplier-list',
    SUPPILER_MASS_UPLOAD: '/supplier-mass-upload',
    SUPPLIER_MASTER_CREATE: '/supplier-master-creation',
    SUPPLIER_DETAILED_PAGE_CREATE:'/supplier-details',
    SUPPLIER_DETAILED_PAGE_WORKFLOW:'/supplier-details-workflow',

    // Vendor
    VENDOR_REGISTRATION: '/vendor-registration',
    VENDOR_REGISTRATIONV2: '/vendor-registrationv2',
    VENDOR_SELFREGISTRATIONV1: '/vendor-selfregistration',
    VENDOR_REGISTRATIONV1_DETAILS: '/vendor-registration-detials',

    VENDOR_LIST: '/vendor-list',
    VENDOR_DETAILPAGE_WORKFLOW: '/vendor-detailpage-workflow',
    VENDOR_DETAILS: '/vendor-details',

    // PQ Vendor List (separate from vendor list)
    PQ_VENDOR_LIST: '/pq-vendor-list',
    PQ_VENDOR_DETAILS: '/pq-vendor-details',
    PQ_SUBMISSION_DETAILS: '/pq-submission-details',
    PQ_VENDOR_WORKFLOW: '/pq-vendor-workflow',


    // SOURCING 
    SOURCING_PURCHASE_REQUISITION_LIST: '/purchase-requisition',
    SOURCING_PURCHASE_REQUISITION_CREATE: '/create-purchase-requisition',
    SOURCING_PURCHASE_REQUISITION_DETAILED_PAGE: '/purchase-requisition-details',

    SOURCING_VENDOR_REQUEST_FOR_QUOTATION: '/supplier-request-for-quotation',
    SOURCING_VENDOR_QUOTATION_LIST: '/supplier-quotation',
    SOURCING_VENDOR_RFQ_DETAILS: '/supplier-rfq-details',  
    SOURCING_CREATE_QUOTATION:'/create-quotation',
    SOURCING_QUOTATION_DETAILS:'/quotation-details',
    
    SOURCING_BUYER_REQUEST_FOR_QUOTATION: '/buyer-request-for-quotation',
    SOURCING_BUYER_RFQ_DETAILS: '/buyer-rfq-details',    
    SOURCING_BUYER_QUOTATION_LIST: '/buyer-quotation',
    SOURCING_CREATE_RFQ: '/create-request-for-quotation',
    SOURCING_CREATE_MANUAL_RFQ: '/create-manual-rfq',

    SOURCING_COMMERCIAL_EVALUATION: '/commercial-evaluation',
    SOURCING_COMMERCIAL_EVALUATION_DETAILS: '/commercial-evaluation-details',
    SOURCING_TECHNICAL_EVALUATION: '/technical-evaluation',
    SOURCING_PURCHASE_ORDER_CREATION: '/create-purchase-orders',

    SOURCING_TECH_EVALUATION_REQUEST_FOR_QUOTATION: '/tech-request-for-quotation',
    SOURCING_TECH_EVALUATION_DETAILS: '/tech-rfq-details',

    SOURCING_RFX_EVALUATION_DETAILS: '/rfx-evaluation-details',

    // SAMPLE MANAGEMENT
    SAMPLE_REQUEST_CREATE: '/create-sample-request',
    SAMPLE_REQUEST_LIST: '/sample-request',
    SAMPLE_REQUEST_ARTWORK: '/sample-request-artwork',
    SAMPLE_REQUEST_APPROVAL: '/sample-request-approval',

    // Purchasing
    SOURCING_PURCHASE_CREATE_PO: '/purchase-order-creation',
    SOURCING_PURCHASE_ORDER_CREATION2: '/purchase-order-creationp2',
    
    SOURCING_PURCHASE_REQUISITION_CREATIONPR:'/purchase-requisition-creationpr',

    //PO COLLABRATION    
    POCOLLABRATION_SERVICE_PURCHASE_ORDER_LIST:'/service-purchase-order',
    POCOLLABRATION_PURCHASE_ORDER_LIST:'/purchase-order',
    POCOLLABRATION_PURCHASE_ORDER_CREATION:'/create-purchase-order',
    POCOLLABRATION_PURCHASE_ORDER_DETAIL_PAGE:'/purchase-order-detail',
    POCOLLABRATION_GOODS_RECEIVED_NOTE:'/goods-received-note',
    POCOLLABRATION_SERVICE_ENTRY_SHEET:'/service-entry-sheet',
    POCOLLABRATION_INVOICE_CREATION:'/create-invoice',
    POCOLLABRATION_INVOICE_CREATION_SES:'/create-invoice-ses',
    POCOLLABRATION_INVOICE:'/invoice',
    POCOLLABRATION_INVOICE_DETIAILS:'/invoice-details',
    POCOLLABRATION_PAYMENT_LIST:'/payments',
    POCOLLABRATION_ASN:'/advanced-shipping-notice',    
    POCOLLABRATION_ASN_DETAIL_PAGE:'/asn-detail',
    POCOLLABRATION_ASN_CREATION:'/create-asn',
    POCOLLABRATION_SA_ASN_CREATION:'/create-sa-asn',
    POCOLLABRATION_GRN_CREATION:'/create-grn',
    POCOLLABRATION_GRN_DETAILS:'/goods-received-note-details',
    POCOLLABRATION_SES_CREATION:'/create-entrysheet',
    POCOLLABRATION_SCHEDULING_AGREEMENT:'/scheduling-agreement',
    POCOLLABRATION_SERVICE_ENTRY_DETAILS:'/service-entry-sheet-details',
    
    
    //SAP REPROCESS
    SAPREPROCESS_GRN_REPROCESS:'/grn-reprocess',
    SAPREPROCESS_SES_REPROCESS:'/ses-reprocess',
    SAPREPROCESS_INVOICE_REPROCESS:'/invoice-reprocess',

    
    //USER DELEGATION
    USER_DELEGATION:'/user-deletion',

    //SINGLE SOURCING 
    SINGLESOURCING_SINGLE_SOURCING_CREATION:'/single-source-create',
    SINGLESOURCING_SINGLE_SOURCING_LIST:'/single-source-list',
    SINGLESOURCING_SINGLE_SOURCING_DETAILS:'/single-source-details',

    //AdvancePayment
    ADVANCE_PAYMENT_ADVANCE_PAYMENT_REQUEST_CREATION:'/advance-payment-request-create',
    ADVANCE_PAYMENT_ADVANCE_PAYMENT_REQUEST_LIST:'/advance-payment-request-list',
    ADVANCE_PAYMENT_ADVANCE_PAYMENT_REQUEST_DETAILS:'/advance-payment-request-details',

    //USER MANUAL
    USER_MANUAL_BUYER_MANUAL:'/buyer-manual',
    USER_MANUAL_SUPPLIER_MANUAL:'/supplier-manual',

    //GHG - GREEN HOUS GAS 
    GHG_SCOPE1_CREATION:'/ghg-scope1-create',

    //ADMIN
    ADMIN_MANAGE_USER_LIST:'/manage-user',
    ADMIN_MANAGE_ADD_USER:'/manage-add-user',
    ADMIN_MANAGE_EDIT_USER:'/manage-edit-user',
    ADMIN_MANAGE_USER_LIST_DETAILS:'/manage-user-detials',
    ADMIN_MANAGE_ROLE:'/manage-role',

    //AUCTION
    // AUCTION_REVERSE_AUCTION_LIST:'/reverse-auction-list',
    AUCTION_REVERSE_AUCTION_CREATION:'/create-auction',
    // AUCTION_REVERSE_AUCTION_HISTORY:'/reverse-auction-history',
    AUCTION_FORWARD_AUCTION_LIST:'/forward-auction-list',
    AUCTION_FORWARD_AUCTION_HISTORY:'/forward-auction-history',

    //CONTRACT MANAGEMENT  
    CONTRACTMANAGEMENT_CONTRACT_GENERATE_LIST:'/contract-generate-list',
    CONTRACTMANAGEMENT_CONTRACT_REVIEW_LIST:'/contract-review-list',
    CONTRACTMANAGEMENT_CONTRACT_DRAFT_TO_FINAL_LIST:'/contract-draft-final-list',
    CONTRACTMANAGEMENT_MONITORING_LIST:'/contract-monitoring-list',

    //GATEPASS
    GATEPASS_GATEPASS_CREATE:'/gatepass-create',
    GATEPASS_GATEPASS_LIST:'/gatepass-list',
    GATEPASS_GATEPASS_DETAIL_PAGE:'/gatepass-detail',
  
    //DELEGATION
    DELEGATION_TASK:'/task-delegation',
    DELEGATION_USER:'/user-delegation',

    //REPORTS
    SUPPLIER_REPORTS:'/supplier-reports',
    SUPPLIER_REPORT_DETAILS:'/supplier-report-details',

    /* catalog */
    MATERIAL_CATALOG_LIST:'/material-catalog',
    MATERIAL_CATALOG_MASTER:'/material-catalog-master',

    /* Material Catalog  Shopwise */
    MATERIAL_CATALOG_SHOPWISE:'/material-catalog-shopwise',

    //CATEGORY
    CATEGORY_LIST:'/category-list',
    CREATE_CATEGORY:'/create-category',
    CATEGORY_DETAILS:'/category-detials',

    //INVOICE DOWN PAYMENT
    INVOICE_DOWN_PAYMENT_LIST:'/invoice-down-payment-list',
    INVOICE_DOWN_PAYMENT_CREATE:'/invoice-down-payment-create',

    //SAP PO
    SAP_PURCHASE_ORDER_LIST:"/sap-purchase-order",
    SAP_PURCHASE_ORDER_DETAIL_PAGE:'/sap-purchase-order-detail',

    //EAuction
    EAUCTION_BUYERAUCTION_LIST:"/reverse-auction-list",
    EAUCTION_BUYERAUCTIONHISTORY_LIST:"/reverse-auction-history",
    EAUCTION_LIVE_AUCTION:"/live-reverse-auction",
    EAUCTION_BUYERAUCTION_CREATE: "/reverse-auction-create",
    EAUCTION_BUYERAUCTION_DETAILS: "/reverse-auction-details",
    EAUCTION_LIVE_AUCTION_DETAILS: "/live-reverse-auction-details",
    // supplier
    EAUCTION_SUPPLIER_AUCTION_LIST:"/supplier-reverse-auction-list",
    EAUCTION_SUPPLIER_AUCTION_DETAILS:"/supplier-reverse-auction-details",
    EAUCTION_SUPPLIER_AUCTION_HISTORY:"/supplier-reverse-auction-history",
    EAUCTION_SUPPLIER_LIVE_AUCTION_DETAILS:"/supplier-reverse-live-auction",

    //material master
    SUPPLIER_MATERIAL_LIST:'/supplier-material-list',
    SUPPLIER_SERVICE_MATERIAL_LIST:'/supplier-service-material-list',
    
    //Finance
    SUPPLIER_FINANCE_ADVANCE_PAYMENT_CREATE:'/supplier-advance-payment-create',
    SUPPLIER_FINANCE_ADVANCE_PAYMENT_DETAILS:'/supplier-advance-payment-details',
    SUPPLIER_FINANCE_ADVANCE_PAYMENT_LIST:'/supplier-advance-payment-list',

    VENDOR_PERFOMANCE_LIST:"/vendor-performance-list",
    POCOLLABRATION_QUALITY_CHECK_LIST:'/quality-check-list',
    POCOLLABRATION_QUALITY_CHECK_CREATE:'/quality-check-create',
    POCOLLABRATION_QUALITY_CHECK_DETAILS:'/quality-check-details',
    POCOLLABRATION_QUALITY_CHECK_UPDATE:'/quality-check-update',
    
     

  
    /* Routers Link */
    NOT_FOUND: "pages-faq.html",
    LOGIN: "/login",
    REGISTER: '/registeration',
    CALLBACK: '/callback',

    
    SETTINGS: '/settings',
    PROFILE: '/profile',
    COMPANY: '/company',

    /* Company Creation (Supplier App) */
    COMPANY_CREATION_LIST: '/company-creation-list',
    COMPANY_CREATION_CREATE: '/company-creation-create',
    COMPANY_CREATION_UPDATE: '/company-creation-update',
    COMPANY_CREATION_DETAILS: '/company-creation-details',

    /* Budget Creation (Supplier App) */
    BUDGET_LIST: '/budget-list',
    BUDGET_CREATE: '/budget-create',
    BUDGET_DETAILS: '/budget-details',
    PAYMENT: '/payment',
    USERS: '/users',
    LOCATION: '/location',
    UPCOMING_SHIFT: '/upcoming-shifts',
    ONGOING_SHIFT: '/todays-shifts',
    PAST_SHIFT: '/past-shifts',
    EVENT_DETAILS: '/event-details',
    EDIT_TIMESHEET: '/edit-timesheet',
    MANAGE_SHIFT: '/manage-shift',
    BOOKSHIFT: '/bookshift',

    VENDOR_PREASSESMENT_FORM: '/preassesment-form',
    VENDOR_PREASSESMENT_FORM_DETAILS: '/preassesment-details-form',

    // Vendor Pre-Qualification (Invite + Assessment flow)
    VENDOR_INVITE_SUPPLIER: '/vendor-invite-supplier',
    VENDOR_MY_ASSESSMENTS: '/vendor-my-assessments',
    VENDOR_PREQUALIFICATION_FORM: '/vendor-prequalification-form',


    /* Positions Master Data */

    ROW_PER_PAGE : [10, 50, 100, 300, 500],
    ROW_REPORT_PER_PAGE : [100, 200, 300, 400, 500],



})

